import { render, staticRenderFns } from "./RegisterStep.vue?vue&type=template&id=12d1a5be&scoped=true"
import script from "./RegisterStep.vue?vue&type=script&lang=js"
export * from "./RegisterStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep.vue?vue&type=style&index=0&id=12d1a5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1a5be",
  null
  
)

export default component.exports